import { createSelector } from 'reselect';

const allDropdownMasters = (state) => state.dropdownMasters;

export const getAllDropdownOptionsData = createSelector(
  [allDropdownMasters],
  (data) => {
    const stateOptionsData = data['stateOptionsData'];
    const districtOptionsData = data['districtOptionsData'];
    const talukaOptionsData = data['talukaOptionsData'];
    const phcOptionsData = data['phcOptionsData'];
    const programOptionsData = data['programOptionsData'];
    const schemeOptionsData = data['schemeOptionsData'];
    const subcenterOptionsData = data['subcenterOptionsData'];
    const areaTypeOptionsData = data['areaTypeOptionsData'];
    const areaCategoryOptionsData = data['areaCategoryOptionsData'];
    const trainingOptionsData = data['trainingOptionsData'];
    const facultyOptionsData = data['facultyOptionsData'];
    const villageOptionsData = data['villageOptionsData'];
    const roleOptionsData = data['roleOptionsData'];
    const lgbOptionsData = data['lgbOptionsData'];
    const accessLevelOptionsData = data['accessLevelOptionsData'];
    const corporationOptionsData = data['corporationOptionsData'];

    const isCorporationLoading = data['isCorporationLoading'];
    const isAccessLevelLoading = data['isAccessLevelLoading'];
    const isLgbLoading = data['isLgbLoading'];
    const isStateLoading = data['isStateLoading'];
    const isDistrictLoading = data['isDistrictLoading'];
    const isTalukaLoading = data['isTalukaLoading'];
    const isPhcLoading = data['isPhcLoading'];
    const isProgramLoading = data['isProgramLoading'];
    const isSchemeLoading = data['isSchemeLoading'];
    const isSubcenterLoading = data['isSubcenterLoading'];
    const isAreaTypeLoading = data['isAreaTypeLoading'];
    const isAreaCategoryLoading = data['isAreaCategoryLoading'];
    const isTrainingLoading = data['isTrainingLoading'];
    const isFacultyLoading = data['isFacultyLoading'];
    const isVillageLoading = data['isVillageLoading'];
    const isRoleLoading = data['isRoleLoading'];

    return {
      stateOptionsData,
      districtOptionsData,
      talukaOptionsData,
      facultyOptionsData,
      phcOptionsData,
      programOptionsData,
      schemeOptionsData,
      trainingOptionsData,
      subcenterOptionsData,
      areaTypeOptionsData,
      areaCategoryOptionsData,
      villageOptionsData,
      roleOptionsData,
      lgbOptionsData,
      accessLevelOptionsData,
      corporationOptionsData,

      isCorporationLoading,
      isAccessLevelLoading,
      isLgbLoading,
      isStateLoading,
      isDistrictLoading,
      isTalukaLoading,
      isPhcLoading,
      isProgramLoading,
      isTrainingLoading,
      isFacultyLoading,
      isSchemeLoading,
      isSubcenterLoading,
      isAreaTypeLoading,
      isAreaCategoryLoading,
      isVillageLoading,
      isRoleLoading,
    };
  }
);

